import { render, staticRenderFns } from "./CountOfRespAssignmentsByLevel.vue?vue&type=template&id=7010b5fe&scoped=true"
import script from "./CountOfRespAssignmentsByLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./CountOfRespAssignmentsByLevel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CountOfRespAssignmentsByLevel.vue?vue&type=style&index=0&id=7010b5fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010b5fe",
  null
  
)

export default component.exports